module.exports = __webpack_public_path__ + "static/media/safari-pinned-tab.3f74671b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicons/safari-pinned-tab.svg
// module id = 98
// module chunks = 0